import React, { useEffect } from "react";
import { TableHeader } from "../../commons";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import CheckinCheckOutAttendanceTableData from "./CheckinCheckOutAttendanceTableData";
import { useLocation } from "react-router-dom";

let tableHeader: TableHeadersType[] = [
  {
    label: "DATE",
    value: "date",
  },
  {
    label: "IN TIME",
    value: "in_time",
  },
  {
    label: "OUT TIME",
    value: "out_time",
  },
  {
    label: "TOTAL WORK HOURS",
    value: "total_work_hours",
  },
  {
    label: "START LOCATION",
    value: "start_location",
  },
  {
    label: "END LOCATION",
    value: "end_location",
  },
  {
    label: "ACTION",
    value: "action",
  },
];

type AppProps = {
  data: any;
  handleToggleSendRegularizeApprovalData: (data: any) => void;
};
const CheckinCheckOutAttendanceTable = ({
  data,
  handleToggleSendRegularizeApprovalData,
}: AppProps) => {
  const { pathname } = useLocation();

  let filterTableHeader = JSON.parse(JSON.stringify(tableHeader));

  if (pathname === "/my-space") {
    filterTableHeader = filterTableHeader?.filter(
      (el: TableHeadersType) => el?.value !== "end_location"
    );
    if (data?.length) {
      data = data?.slice(0, 7);
    }
  }

  return (
    <div className="jobsType" style={{ overflow: "auto" }}>
      <table className="table thead-light">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader
            tableHeader={
              pathname === "/my-space" ? filterTableHeader : tableHeader
            }
          />
        </thead>
        <tbody>
          <CheckinCheckOutAttendanceTableData
            tableHeader={
              pathname === "/my-space" ? filterTableHeader : tableHeader
            }
            data={data}
            handleToggleSendRegularizeApprovalData={
              handleToggleSendRegularizeApprovalData
            }
          />
        </tbody>
      </table>
    </div>
  );
};

export default CheckinCheckOutAttendanceTable;
